export function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
}

export function emptyFunction() {}

export function formatCarouselArray(collection, { size = 3 } = {}) {
    const arrayOfArrays = [];
    for (let i = 0; i < collection.length; i += size) {
        arrayOfArrays.push(collection.slice(i, i + size));
    }
    return arrayOfArrays;
}
